<!-- students -->
<template>
  <div>
    <section-list1
      title="Students"
      :data="sectionListData"
      v-loading="loading"
      :iconButton="$buttonPermission('Class', 'Full') || $buttonPermission('Class', 'Edit')"
      :notAllowed="sectionListData.length <= 0"
      @handleClick="clickStudent"
      @editStaffCallback="editStaffCallback"
      :isAutoBack="true"
      back="Add students in this page."
    >
      <template slot="back">
        <img style="width: 100%" :src="require('@/assets/images/moments/empty.png')" />
      </template>
    </section-list1>
    <SelectDialog
      v-model="isSelectAddShow"
      title="Add students"
      label="fullName"
      :showCheckbox="false"
      :showSeclect="false"
      submitText="Add"
      :data="allStudentList"
      @submit="changeAddSelect"
      @change="changeAdd"
    />
    <SelectDialog
      v-model="isSelectRemoveShow"
      title="Withdraw students"
      label="fullName"
      :showCheckbox="true"
      :showSelect="false"
      :addStudentDes="true"
      :data="removeListData"
      submitText="Withdraw"
      @submit="changeRemoveSelect"
      @change="changeRemove"
    />
    <gg-Dialog :append-to-body="false" :visible.sync="isDialogShow" title="Withdraw students">
      <div class="dialog-content">
        <p class="desc">Are you sure that you want to withdraw these students from the class?</p>
        <ul class="content">
          <li v-for="(item, index) in deleteData" class="item" :key="index">
            <div class="user-img">
              <head-img
                class="user-box"
                :firstName="item.firstName"
                :lastName="item.lastName"
                :src="item.avatar"
                line-height="36"
              ></head-img>
            </div>
            <div class="userInfo">
              <p class="user-name">{{ item.firstName }} {{ item.lastName }}</p>
              <p class="user-email">{{ item.email }}</p>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isDialogShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="handleRemove">Withdraw</gg-submit-button>
      </span>
    </gg-Dialog>
    <Snackbar :visible.sync="isSnackbarShow" :content="snackbarData" />
  </div>
</template>

<script>
import { Ajax } from '@/common'
import { buildBreadcrumb, readState, pushState } from '@/common/nav-state'
import { mapState } from 'vuex'

export default {
  name: 'teachers',
  // 原为 comments: { assign }（本意 components，但模板从未使用 assign，组件已随孤儿文件删除）；
  // 保留 truthy 值以维持模板 HTML 注释节点的现有渲染行为
  comments: true,
  data() {
    return {
      query: {
        size: 20,
        current: 1
      },
      activeIndex: 'teachers',
      removeListData: [],
      sectionListData: [],
      isSelectAddShow: false,
      isSelectRemoveShow: false,
      desc: '0 enrolled students for the class size of 4',
      allStudentList: [],
      isDialogShow: false,
      selesetArr: [],
      deleteData: [],
      isSnackbarShow: false,
      snackbarData: '',
      loading: false,
      deleteDataShow: [],
      classRowsForIdentity: '' // sectionListData 归属的路由身份（selectStudentByClassIdV1 请求身份）
    }
  },
  computed: {
    ...mapState({
      breadcrumb: (state) => state.breadcrumb,
      user: (state) => state.user
    }),
    classId() {
      const s = readState(this.$route, ['classId'])
      return s ? s.classId : ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // let classId = to.params.id;
      // let schoolName = vm.user.schoolName;
      // vm.breadcrumbData = vm.breadcrumb.breadcrumbData;
    })
  },
  watch: {
    '$route.query.classId'() {
      // 同路由 A→B 复用（back/forward）：身份相关取数按新身份重取
      if (!this._guardRouteIdentity()) return
      // 身份切换时清掉上一班级的对话框/暂存行（P1-1：确认框不得跨身份触发）
      this.isSelectAddShow = false
      this.isSelectRemoveShow = false
      this.isDialogShow = false
      this.deleteData = []
      this.deleteDataShow = []
      this.selesetArr = []
      this._getData()
    }
  },
  methods: {
    // 缺失 classId 与详情页同契约：提示并回班级列表（created 与身份切换共用）
    _guardRouteIdentity() {
      if (!readState(this.$route, ['classId'])) {
        if (this.$message) this.$message.error('Missing class')
        this.$router.replace('/classes')
        return false
      }
      return true
    },
    // 写操作的 class 归属：仅当学生列表归属当前路由身份时可信；
    // 新身份响应未到或缺参时拒绝，绝不回落路由查询键或滞留旧行（Ruling R18）
    _verifiedClassRows() {
      if (!this.classId || this.classRowsForIdentity !== this.classId) return false
      return true
    },
    // 通过classId获取学生
    _getData() {
      var data = {
        id: this.classId
      }
      this.loading = true
      // 请求身份：A→B 复用时丢弃过期响应，防旧班级学生覆盖新身份
      const reqId = this.classId
      Ajax.get('/usermanage/classRef/selectStudentByClassIdV1', data).then((res) => {
        if (reqId !== this.classId) return
        let arr = []
        this.sectionListData = res.data || []
        // 记录该列表归属的路由身份：写操作仅在与当前路由身份一致时可信（Ruling R18）
        this.classRowsForIdentity = reqId
        // 赋值删除students的列表
        res.data.forEach((item) => {
          arr.push({
            id: item.id,
            avatar: item.photo,
            firstName: item.firstName,
            lastName: item.lastName,
            fullName: `${item.firstName} ${item.lastName}`,
            email: item.emailAddress,
            isUser: true,
            tipMessage: item.tipMessage
          })
        })
        console.log('remove', this.removeListData)
        this.removeListData = arr
        this.loading = false
      })
    },
    // 获取所有的学生列表
    _getAllStudent() {
      this.loading = true
      //todo
      Ajax.get(`/usermanage/student/getStudentByLocationId/${this.user.locationId}`).then((res) => {
        let response = res.data || []
        let arr = []
        response.forEach((item) => {
          arr.push({
            id: item.id,
            avatar: item.photo,
            firstName: item.firstName,
            lastName: item.lastName,
            fullName: `${item.firstName} ${item.lastName}`,
            email: item.emailAddress,
            isUser: true
          })
        })
        this.allStudentList = arr
        this.loading = false
        console.log(this.allStudentList)
      })
    },
    menuSelect(key, item) {
      console.log(key, item)
      this.activeIndex = key
      this.$router.push(`/${key}`)
    },
    editStaffCallback(isAddStaff) {
      this.isSelectAddShow = isAddStaff
      if (this.sectionListData.length <= 0) {
        return false
      }
      this.isSelectRemoveShow = !isAddStaff
    },
    changeAddSelect(selesetArr) {
      // saveStudentClassRefV2 按 class_id + student_id 匹配（命名空间审计见报告），只能用已核实的班级归属
      if (!this._verifiedClassRows()) {
        this.isSnackbarShow = true
        this.snackbarData = 'Class data is not ready yet, please try again'
        return
      }
      // this.sectionListData = this.sectionListData.concat(selesetArr);
      // let arr = [];
      // this.sectionListData.forEach((item) => {
      //   arr.push(item.id);
      // });

      let arr = []
      selesetArr.forEach((item) => {
        arr.push(item.id)
      })

      let data = {
        classId: this.classId,
        companyId: this.user.companyId,
        locationId: this.user.locationId,
        staffIds: [],
        stuIds: arr,
        type: 'active'
      }
      this.loading = true
      Ajax.post('/usermanage/classRef/saveStudentClassRefV2', data).then((res) => {
        console.log(res)
        if (res.code != 9999) {
          this.isDialogShow = false
          this.isSnackbarShow = true
          this.snackbarData = `${arr.length == 1 ? '' : arr.length} ${arr.length > 1 ? 'students have' : 'Student has'} been added`
          this._getData()
          this._getAllStudent()
          this.loading = false
        } else {
          this.isDialogShow = false
          this.isSnackbarShow = true
          this.snackbarData = `something error`
          this.loading = false
        }
      })
    },
    changeRemoveSelect(selesetArr) {
      this.isDialogShow = true
      this.deleteData = selesetArr
      console.log(this.deleteData)
    },
    changeAdd() {},
    changeRemove(selesetArr) {
      this.deleteDataShow = selesetArr
    },
    handleRemove() {
      // removeStudentClassRefV1 按 class_id + student_id 匹配（命名空间审计见报告），只能用已核实的班级归属
      if (!this._verifiedClassRows()) {
        this.isSnackbarShow = true
        this.snackbarData = 'Class data is not ready yet, please try again'
        return
      }
      let arr = []
      this.deleteData.forEach((item) => {
        arr.push(item.id)
      })
      let data = {
        classId: this.classId,
        companyId: this.user.companyId,
        locationId: this.user.locationId,
        staffIds: [],
        stuIds: arr,
        type: 'closed'
      }
      this.loading = true
      Ajax.post('/usermanage/classRef/removeStudentClassRefV1', data).then((res) => {
        this.loading = false
        this.isDialogShow = false
        this.isSnackbarShow = true
        this.snackbarData = `${this.deleteData.length == 1 ? '' : this.deleteData.length} ${this.deleteData.length > 1 ? 'students have' : 'Student has'} been withdrawn`
        this._getData()
        this._getAllStudent()
      })
    },
    clickStudent(item) {
      // 跳转班级老师之前设置面包屑数据（段列表 + 拉取标签由 buildBreadcrumb 推导）
      let className = this.user.className
      let schoolName = this.user.schoolName
      this.$store.commit(
        'SET_BREADCRUMDATA',
        buildBreadcrumb(this.$route, {
          segments: [
            { routeName: 'locations', from: 'schoolName' },
            { routeName: 'classes', name: 'Classes' },
            { routeName: 'classDetailInfo', from: 'className' },
            { from: 'personName' }
          ],
          schoolName,
          className,
          personName: `${item.firstName} ${item.lastName}`
        })
      )
      // 导航参数进 URL（Ruling R1/R10）：必填 id/type + 逐键可选标签，不再写 studentInfo
      pushState(this.$router, {
        name: 'studentsInfo',
        query: {
          id: item.id,
          type: '1',
          className,
          locationName: schoolName,
          class: 'true'
        }
      })
    }
  },
  created() {
    // 缺失 classId 与详情页同契约：提示并回班级列表，不再空身份取数
    if (!this._guardRouteIdentity()) return
    this._getData()
    this._getAllStudent()
  }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog__title {
  font-family: OpenSans-bold;
}
.dialog-content {
  color: #202124;
  .desc {
    margin: 18px 0 26px;
  }
  .content {
    .item {
      width: 100%;
      height: 100%;
      margin-bottom: 20px;
      padding-left: 0;
      display: flex;
      align-items: center;
      font-family: Roboto;
      line-height: 20px;
      .user-img {
        margin-right: 20px;
      }
    }
  }
}
/deep/.el-dialog {
  width: 580px;
}
/deep/.dialog-content .desc {
  font-family: Roboto;
}
/deep/.md-ripple-leave-active {
  display: none !important;
}
</style>

<!-- 以下非 scoped 规则迁移自已删除的 Assign.vue（177-180）：
     它曾随 students chunk 的组件 import 全局注入，删除文件会丢失该规则，
     改变 .md-field .md-input 的字体解析（Roboto → fallback stack），故在此原样保留 -->
<style lang="less">
.md-field .md-input {
  font-family: Roboto;
}
</style>
